<template>
    <ValidationObserver
        ref="connectWorksToSheetDialog"
        v-slot="{ passes }"
    >
        <BaseDialog
            :showDialog="showDialog"
            :headline="headline"
            :close="close"
            :scrollable="true"
            maxDialogWidth="800"
            maxCardHeight="800"
            :alvqa="alvqa"
        >
            <template v-slot:dialogText>
                <v-container fluid v-if="!showWorkFields">
                    <v-row>
                        <v-col cols="10">
                            <SearchFilter 
                                :context="context" 
                                @keydown.enter="searchForListItems"
                                :alvqa="alvqa + '-textfield-search'"
                            />
                        </v-col>
                        <v-col align-self="end" class="text-left">
                            <BaseIcon 
                                @click="searchForListItems" 
                                icon="fa-search" 
                                tooltipText="lang_GENERIC_CAPTION_SEARCH"
                                :alvqa="alvqa + '-button-search'"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="showSearchResult" class="pb-3">
                        <v-col v-if="items.length !== 0" class="pl-7">
                            <!--  CHECKBOX TO SELECT ALL ITEMS -->
                            <v-checkbox
                                :alvqa="alvqa + '-checkbox-all-select'"
                                v-model="allSelected"
                                @click.stop="selectAll"
                                hide-details
                                color="generalCheckbox"
                                :disabled="disabledAllSelect"
                            >
                                <template v-slot:label>
                                    <BaseHeaderStats 
                                        :context="context" 
                                        typeStats="DIALOG"
                                        :alvqa="alvqa"
                                        useContextForTotal="SearchDialog"
                                    />
                                </template>
                            </v-checkbox>
                            <!-- <BaseHeaderStats 
                                :context="context" 
                                typeStats="DIALOG"
                                :alvqa="alvqa"
                                useContextForTotal="ConnectVenueToSheetDialog"
                            /> -->
                        </v-col>
                        <v-col 
                            v-else
                            :alvqa="alvqa + '-text-none-found'"
                        >
                        0 {{ $t('lang_GENERAL_CAPTION_FOUND') }}
                        </v-col>
                    </v-row>
                    <v-divider v-if="items.length > 0"></v-divider>
                    <v-list two-line>
                        <v-list-item-group
                            v-model="selected"
                            :multiple="true"
                            @change="checkSelectAll()"
                        >
                            <v-list-item
                                 v-for="(item, i) in items"
                                :key="item.alvId"
                                :value="i"
                                :alvqa="alvqa + '-result-list-row-' + item.alvId"
                                @click="selectItem(item.alvId, i)"
                                :disabled="item.alvInternalDisable"
                            >
                                <!-- <v-list-item-content>
                                    <v-list-item-title :alvqa="alvqa + '-result-list-row-' + item.alvId + '-name'">
                                        {{ item.name }} ({{ item.alvId }})
                                    </v-list-item-title>
                                    <v-list-item-subtitle :alvqa="alvqa + '-result-list-row-' + item.alvId + '-subtitle'">
                                        {{ item.zip }} {{ item.city }}, {{ $alvPlugin.getTranslatedCountryName(item.country)  }}
                                    </v-list-item-subtitle>
                                </v-list-item-content> -->
                                <template v-slot:default="{ active }">
                                    <v-list-item-action class="mr-2">
                                        <!--  CHECKBOX TO SELECT A SPECIFIC ITEM -->
                                        <v-checkbox
                                            :input-value="active"
                                            color="generalCheckbox"
                                            hide-details
                                            :disabled="item.alvInternalDisable"
                                            :alvqa="alvqa + '-result-list-row-' + item.alvId + '-checkbox'"
                                        ></v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title :alvqa="alvqa + '-result-list-row-' + item.alvId + '-title'">
                                            {{ item.title }} {{ item.gemaNumber ? '(' + item.gemaNumber + ')' : '' }}
                                        </v-list-item-title>
                                        <div class="ellipsis subtitle">
                                            <BaseTooltip
                                                :alvqa="alvqa + '-result-list-row-' + item.alvId + '-title'"
                                                :simpleText="getInterestedParties(item)"
                                            >
                                            </BaseTooltip>
                                        </div>
                                        <!-- <v-list-item-subtitle :alvqa="alvqa + '-result-list-row-' + item.alvId + '-subtitle'">
                                            <span v-if="item.length !== 0 && item.workSocieties.length !== 0">
                                            <span 
                                                v-for="(interestedParty, i) in item.workSocieties[homeSocietyCode].parties"
                                                :key="i"
                                            >{{ interestedParty.name }}({{ interestedParty.role }}){{ i+1 == item.workSocieties[homeSocietyCode].parties.length ? '': ', '}}</span> 
                                            </span>
                                        </v-list-item-subtitle> -->
                                    </v-list-item-content>
                                </template>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-container>
                <v-container fluid v-else-if="showWorkFields">
                    <v-row>
                         <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="WorkTitle"
                                :label="$t('lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE')" 
                                rules="required"
                                :withMargin="false"
                                :clearable="false"
                                :alvqa="alvqa + '-textfield-work-title'"
                            />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Interpret"
                                :label="$t('lang_PUBLISHING_SHEETS_WORKS_DIALOG_CAPTION_INTERPRET_COMPOSER')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-interpret'"
                                rules="required"
                            />
                        </v-col>
                   </v-row>
                   <v-row v-if="sheetType === 'setlist'">
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Duration"
                                :label="getSetTimeCaption('lang_PUBLISHING_WORKS_CAPTION_DURATION')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-setlist-set-start-time'"
                                rules="timeHoursMinutes"
                            />
                        </v-col>
                        <v-col>
                            <BaseEditPageTextField 
                                :context="context"
                                field="Tags"
                                :label="$t('lang_GENERIC_CAPTION_TAGS')"
                                :iconTooltipText="$t('lang_GENERAL_INFO_MESSAGE_WHITE_SPACE_SEPARATED')"
                                :withMargin="false"
                                :alvqa="alvqa + '-textfield-tags'"
                            />
                        </v-col>
                   </v-row>
                </v-container>
            </template>

            <template v-slot:dialogActions>
                <v-container fluid>
                <v-row v-if="!showWorkFields">
                    <v-spacer />
                    <v-col class="text-right">
                        <BaseButton 
                        v-if="sheetType !== 'film/tv'"
                            :disabled="selectedWorkIds.length !== 0" 
                            @click="createNewWork(true)"
                            label="lang_GENERIC_PUBLISHING_CAPTION_CREATE_GHOST_WORK"
                            :alvqa="alvqa +  '-button-create'"
                        />
                    </v-col>
                    <v-col class="text-right">
                        <BaseButton 
                            :disabled="selectedWorkIds.length === 0" 
                            @click="addWork()"
                            label="lang_PUBLISHING_SHEETS_BUTTON_CAPTION_ADD_WORKS"
                            :alvqa="alvqa +  '-button-select'"
                        />
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-spacer />
                    <v-col class="text-right">
                        <BaseButton 
                            @click="backToSearch()"
                            label="lang_GENERAL_BUTTON_CANCEL"
                            :alvqa="alvqa +  '-button-back'"
                        />
                    </v-col>
                    <v-col class="text-right">
                        <BaseButton 
                            @click="passes(connectAndSaveVenue)"
                            label="lang_GENERIC_CAPTION_SAVE_AND_CONNECT"
                            :alvqa="alvqa +  '-button-save-connect'"
                        />
                    </v-col>
                </v-row>
            </v-container>
            </template>
        </BaseDialog>
    </ValidationObserver>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import SearchFilter from '@/components/_filters/SearchFilter'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseTooltip from '@/components/_base/BaseTooltip'

import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'

export default {
    name: "SheetsWorksPanelAddWorksDialog",
    components: {
        BaseDialog,
        SearchFilter,
        BaseIcon,
        BaseHeaderStats,
        BaseButton,
        BaseTooltip,

        BaseEditPageTextField,
    },
    data() {
        return {
            alvqa: "publishing-sheets-edit-form-works-panel",
            showWorkFields: false,
            context: 'SheetWork',
            selected: [],
            allSelected: false,
            showSearchResult: false,
            items: [],
            disabledAllSelect: false,

            createNew: false,
            headline: "lang_PUBLISHING_SHEETS_BUTTON_CAPTION_ADD_WORKS",
            venueContext: "AzLive"
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowConnectWorksToSheetDialog },
            set(show) { this.$store.commit("setShowConnectWorksToSheetDialog", show) }
        },
        selectedWorkIds: {
            get() { return this.$store.getters.getSelectedSheetWork },
            set(venue) { this.$store.commit("setSelectedSheetWork", venue) }
        },
        countries() { return this.$alvPlugin.getListOfTranslatedCountries() },
        sheetType() { return this.$store.getters.getSheetDetailsType },
    },
    methods: {
        getInterestedParties(item){
            let parties = item.interestedParties.map(element => {
                return element.name + ' (' + element.role + ')'
            }).join(", ")
            return parties
        },
        close() {
            this.showDialog = false
            this.showWorkFields = false
            this.selectedWorkIds = []
            this.showSearchResult = false
            this.selected = []
            this.items = []
            this.allSelected = false
            this.disabledAllSelect = false
            this.createNew = false
            this.headline = "lang_PUBLISHING_SHEETS_BUTTON_CAPTION_ADD_WORKS"

            this.$store.commit('setSheetWorkSearch', '')
            this.$store.commit('setSheetWorkDetailsInterpret', null)
            this.$store.commit('setSheetWorkDetailsWorkTitle', null)
            this.$store.commit('setSheetWorkDetailsDuration', null)
            this.$store.commit('setSheetWorkDetailsTags', null)
            // this.$store.commit('setTotalListedConnectVenueToSheetDialog', 0)
            // this.$store.commit('setTotalRecordsConnectVenueToSheetDialog', 0)
        },
        async searchForListItems() {
            this.$store.commit('setIsLoading', true)
            let search = this.$store.getters.getSheetWorkSearch
            if(search) {
                this.selectedWorkIds = []
                this.selected = []
                this.allSelected = false
                this.showSearchResult = true
                
                this.items = await this.$store.dispatch('searchSheetWork')
            }

            if(!search) this.items = []

            let selectable = this.items.reduce((num, item) => num + Number(!item.alvInternalDisable), 0)
            this.disabledAllSelect = selectable == 0

            this.$store.commit('setTotalListedSearchDialog', selectable)
            this.$store.commit('setTotalRecordsSearchDialog', this.items.length)
            this.$store.commit('setIsLoading', false)
        },
        createNewWork() {
            this.showWorkFields = true
            this.headline = 'lang_PUBLISHING_WORK_BUTTON_CAPTION_NEW_WORK'
        },
        async addWork() {
            let selectedItems = []
            for(let i = 0; i < this.selected.length; i++) {
                selectedItems.push(this.items[this.selected[i]]) // to add the full items in frontend data table
            }
            await this.$store.dispatch('addWorksToSheet', selectedItems) 
            this.searchForListItems()
        },
        selectAll() {
            if(this.allSelected == true) {
                this.selected = []
                this.selectedWorkIds = []
                for(let i = 0; i < this.items.length; i++) {
                    if( this.items[i].alvInternalDisable != true ){
                        this.selected.push(i)
                        this.selectedWorkIds.push(this.items[i].alvId)
                    }
                }
            } else {
                this.selected = []
                this.selectedWorkIds = []
                this.allSelected = false
            }
        },   
        checkSelectAll(){
            let selectable = this.items.reduce((num, item) => num + Number(!item.alvInternalDisable), 0)

            if(this.selected.length === this.items.length || (selectable > 0 && selectable === this.selected.length)) 
                this.allSelected = true
            else 
                this.allSelected = false
        },
        selectItem(alvId, rowId) {
            let indexOfItem = this.selected.indexOf(rowId) 
            if(indexOfItem >= 0) {
                this.selectedWorkIds.splice(this.items[rowId].alvId, 1)
            }
            else {
                this.selectedWorkIds.push(this.items[rowId].alvId)
            }
        },
        async connectAndSaveVenue() {
            // Save the new ghost work
            let defaultWork = this.$store.getters.getDefaultNewWork
            defaultWork['title'] = this.$store.getters.getSheetWorkDetailsWorkTitle
            defaultWork['duration'] = this.$store.getters.getSheetWorkDetailsDuration
            defaultWork['tags'] = this.$store.getters.getSheetWorkDetailsTags
            defaultWork['status'] = 'ghost'
            this.$store.commit('setWorksOtherPersons', [
                {
                    type: "IN", 
                    name: this.$store.getters.getSheetWorkDetailsInterpret
                }
            ])

            this.$store.commit('setWorksDetails', defaultWork)
            await this.$store.dispatch("saveWorksForm", false)

            // add the new created work to the panel
            let newWork = this.$store.getters.getWorksDetails
            await this.$store.dispatch('addWorksToSheet', [newWork])

            this.$store.commit('setDefaultNewWork') // set back the default work data
            // this.$store.commit('setSheetDetailsEventVenue', venue)
            // this.$store.commit('setSheetDetailsEventVenueId', venue.id)
            this.close()
        },
        backToSearch() {
            this.showWorkFields = false
            this.headline = 'lang_PUBLISHING_SHEETS_BUTTON_CAPTION_ADD_WORKS'
        },
        getSetTimeCaption(baseString) {
            let caption = this.$t(baseString)
            caption += " (HH:MM)" 
            return caption
        },
    },
    mounted() {
        this.$store.commit('setCountries')
    }
}
</script>

<style>
    .subtitle {
        color: rgb(143, 142, 142);
        font-size: 10.3pt;
        font-weight: light;
    }
</style>